// Activate Bootstrap popovers
$(function()
{
    $("[data-toggle='popover']").popover();
});
